import { createSelector } from 'reselect';

import { propSelector } from '../../selectors';
import aboutLinksSelector from './aboutLinksSelector';
import appLinksSelector from './appLinksSelector';
import offerLinksSelector from './offerLinksSelector';
import siteSectionsLinksSelector from './siteSectionsLinksSelector';

/*
 *  PUT (re)SELECTORS TOGETHER
 */
export default createSelector(
  [
    propSelector,
    aboutLinksSelector,
    appLinksSelector,
    offerLinksSelector,
    siteSectionsLinksSelector,
  ],
  (props, aboutLinks, appLinks, offerLinks, siteSectionLinks) => ({
    links: {
      aboutLinks,
      appLinks,
      offerLinks,
      siteSectionLinks,
    },
    ...props,
  })
);
